/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { CardMedia, Container, Typography, Card, Box, Stack, Divider, Skeleton, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { HashLink } from 'react-router-hash-link';
import DynamicButton from './section/DynamicButton';
import TextMaxLine from '../../components/text-max-line';
import { useDevice } from '../../hooks/useResponsive';
import { mockProductsData } from '../../mock/productsData';
import { fetchDynamicPrices, getMergedProductsData } from '../../utils/pricingService';
import EstimateCard from './EstimateCalculation';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ExpertHomeVisitSectionEstimate from './section/ExpertHomeVisitSection';

// import BookingDialog from './Booking/BookingModal';
// import { styledCurtains } from './Home';
// import
export default function EstimatePageMobile() {
  const { isMobile } = useDevice();
  const location = useLocation();
  const [allProducts, setAllProducts] = useState(mockProductsData);
  const loading = false;
  const locationData = location?.state;

  const [selectedCurtain, setSelectedCurtain] = useState(mockProductsData.products[0]);
  const handleCurtainTypeChange = (item) => {
    setSelectedCurtain(item);
  };

  useEffect(() => {
    let isMounted = true;
    fetchDynamicPrices().then((prices) => {
      if (isMounted && prices) {
        const merged = getMergedProductsData(prices);
        setAllProducts(merged);
        setSelectedCurtain((prev) => {
          const updated = merged.products.find((p) => p._id === prev?._id);
          return updated || prev;
        });
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (locationData) {
      const currentItem = allProducts?.products?.filter((i) => i._id === locationData);
      if (currentItem && currentItem[0]) {
        setSelectedCurtain(currentItem[0]);
      }
      window.scrollTo({
        top: 400,
        behavior: 'smooth',
      });
    } else if (allProducts?.products && allProducts.products[0]) {
      setSelectedCurtain((prev) => {
        const found = allProducts.products.find((p) => p._id === prev?._id);
        return found || allProducts.products[0];
      });
    }
  }, [allProducts?.products, locationData]);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      {/* Top Return Bar for Mobile */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1100,
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.2,
          borderBottom: '1px solid #eaeaea',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        }}
      >
        <Button
          href="https://zealcurtains.com"
          startIcon={<ArrowBack sx={{ fontSize: '16px !important' }} />}
          sx={{
            textTransform: 'none',
            fontSize: '12px',
            fontWeight: 600,
            color: '#1a1a1a',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dcdcdc',
            borderRadius: '20px',
            px: 1.8,
            py: 0.5,
            '&:hover': {
              backgroundColor: '#0f172a',
              color: '#ffffff',
            },
          }}
        >
          ← Back to Zeal Curtains Home
        </Button>

        <Box
          component="a"
          href="https://zealcurtains.com"
          sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <img src="/assets/logo-black.png" alt="Zeal Curtains" style={{ height: 26 }} />
        </Box>
      </Box>

      {/* <img
        src={selectedCurtain?.logoImage || '/assets/images/Estimate/banner2.png'}
        alt="Selected Curtain Banner"
        style={{ width: '100%', height: 'auto', objectFit: 'cover', aspectRatio: '12/9' }}
      /> */}
      <div style={{ position: 'relative', width: '100%', overflowX: 'clip' }} className="zeal-estimate-banner">
        {/* Overlay Text */}
        <div
          className="roboto-sans-light-bold"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            padding: '10px 24px',
            background: 'rgba(0, 0, 0, 0.3)', // semi-transparent background
            color: 'white',
            fontSize: '18px',
            zIndex: 1,
          }}
        >
          Get Instant Estimate{' '}
        </div>

        {/* Image */}
        {/* {selectedCurtain?.banner_image?.length > 0 ? (
          <Slider {...settings} >
            {selectedCurtain?.banner_image.map((img, index) => (
              <img
                key={index}
                src={img.url}
                alt={`Curtain ${index + 1}`}
                className="banner-image"

              />
            ))}
          </Slider>
        ) : (
          <Skeleton
            variant="rectangular"
            sx={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              aspectRatio: '14/9',
              display: 'block',
            }}
          />
        )} */}
        {Array.isArray(selectedCurtain?.banner_image) ? (
          selectedCurtain.banner_image.length > 0 ? (
            <Slider {...settings}>
              {selectedCurtain.banner_image.map((img, index) => (
                <img
                  key={index}
                  src={img.url}
                  alt={`Curtain ${index + 1}`}
                  className="banner-image"
                  style={{
                    width: '100%',
                    height: '393px',
                    objectFit: 'cover',
                    display: 'block',
                    borderRadius: '4px',
                  }}
                />
              ))}
            </Slider>
          ) : (
            // eslint-disable-next-line jsx-a11y/img-redundant-alt
            <img
              src="/assets/images/noImage/noImage.svg"
              alt="No Image"
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
                aspectRatio: '14/9',
              }}
            />
          )
        ) : (
          <Skeleton
            variant="rectangular"
            sx={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              aspectRatio: '14/9',
              display: 'block',
            }}
          />
        )}
      </div>

      <Box
        sx={{
          // marginTop: selectedCurtain?.banner_image?.length < 0 ? 0 : '-19px',
          paddingBottom: isMobile ? 0 : '20px',
        }}
      >
        <Container
          className="EstimateContainer"
          maxWidth="lg"
          sx={{ paddingTop: isMobile ? 0 : '25px', paddingBottom: '12px', px: isMobile ? 0 : '' }}
        >
          <Stack
            // mt={isMobile && -10}
            flexWrap={'wrap'}
            direction={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Card
              sx={{
                width: '100%',
                mx: 1,
                my: 1,
                boxShadow: 'unset',
                borderRadius: 0,
                // boxShadow: isMobile
                //   ? '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
                //   : 'none',
              }}
            >
              <Typography
                gutterBottom
                className="roboto-sans-light-bold"
                sx={{
                  color: 'black',
                  ml: 1,
                  fontWeight: '800',
                  fontSize: isMobile ? '16px' : '24px',
                  textAlign: 'left',
                }}
                noWrap
              >
                Choose Product{' '}
              </Typography>

              <Stack sx={{ textAlign: 'center', p: 0 }}>
                {loading ? (
                  <Stack direction="row" mt={1} spacing={2} sx={{ width: '100%' }}>
                    {[1, 2, 3, 4].map((_, idx) => (
                      <Box key={idx} sx={{ flex: 1, position: 'relative' }}>
                        <Box
                          sx={{
                            width: '100%',
                            paddingTop: '100%', // Taller box (height = 125% of width)
                            position: 'relative',
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                            }}
                          />
                        </Box>
                      </Box>
                    ))}
                  </Stack>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      overflowX: 'auto',
                      gap: 1.3,
                      px: 0.5,
                      '&::-webkit-scrollbar': { display: 'none' },
                    }}
                  >
                    {' '}
                    {allProducts?.products && allProducts.products.length > 0 ? (
                      allProducts?.products?.map((card) => (
                        <Box
                          key={card._id}
                          onClick={() => handleCurtainTypeChange(card)}
                          // onMouseEnter={() => {
                          //   console.log('Hovered:', card.name);
                          //   handleCurtainTypeChange(card);
                          // }}
                          sx={{
                            flex: '0 0 auto',
                            width: selectedCurtain?._id === card._id ? '125px' : '107px', // Slight expansion on selection
                            textAlign: 'center',
                            border: selectedCurtain?._id === card._id ? '2px solid #ED262980' : '1px solid transparent',
                            borderRadius: selectedCurtain?._id === card._id ? '8px ' : '13px',
                            position: 'relative',
                            cursor: 'pointer',
                            backgroundColor: '#fff',
                          }}
                        >
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 0 }}>
                            <CardMedia
                              component="div"
                              sx={{
                                width: '100%',
                                height: '62px',
                                overflow: 'hidden',
                                borderRadius: selectedCurtain?._id === card._id ? '6px 6px 0 0' : '4px',
                              }}
                            >
                              {/* <img
                                src={card.banner_image ? card.banner_image[0] : '/assets/images/noImage/noImage.svg'}
                                alt={card.alt}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              /> */}
                              {card?.banner_image?.length > 0 ? (
                                <img
                                  src={
                                    card.banner_image ? card.banner_image[0]?.url : '/assets/images/noImage/noImage.svg'
                                  }
                                  alt={card.alt}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              ) : (
                                <img
                                  src={'/assets/images/noImage/noImage.svg'}
                                  alt="no Img"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              )}
                            </CardMedia>

                            <TextMaxLine
                              className="roboto-sans-medium"
                              line={2}
                              persistent
                              sx={{
                                px: selectedCurtain?._id === card?._id ? 1 : 0,
                                py: 1,
                                color: 'black',
                                fontSize: '10px',
                                textTransform: 'capitalize',
                                textAlign: 'left',
                                lineHeight: '14px', // Or however tall each line should be
                                height: '36px', // 2 lines * 14px
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {card?.name}
                            </TextMaxLine>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography
                        variant="body2"
                        sx={{
                          my: 5,
                          textAlign: 'center',
                          width: '100%',
                          color: 'text.secondary',
                          fontStyle: 'italic',
                        }}
                      >
                        No product found
                      </Typography>
                    )}
                  </Box>
                )}
              </Stack>
            </Card>
          </Stack>
        </Container>
      </Box>
      <Divider orientation="horizontal" sx={{ mb: 2 }} />
      <EstimateCard
        selectedCurtain={selectedCurtain}
        containerSx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
      <Box sx={{ px: 2, mt: 2, mb: 3 }}>
        <HashLink smooth to={'/booking#booking_top'} style={{ textDecoration: 'none' }}>
          <Button
            variant="contained"
            color="error"
            fullWidth
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              borderRadius: '8px',
              paddingY: '12px',
              textTransform: 'none',
            }}
          >
            Book a Free Home Visit
          </Button>
        </HashLink>
      </Box>
      <Stack mt={1}>
        <DynamicButton text=" Free Material Consultation" color="#1D1D1D" />
      </Stack>
      <ExpertHomeVisitSectionEstimate />
    </>
  );
}
